import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

export const RemoteImage = ({
  width,
  height,
  isCircular,
  remoteSrc,
  fallbackSrc,
  onLoad,
  onError,
  style,
  className,
  alt
}) => {
  const [src, setSrc] = useState(remoteSrc);
  const [error, setError] = useState(false); // prevent infinite loop

  const handleLoad = () => {
    if (!error) {
      setSrc(remoteSrc);
    }
    onLoad?.();
  };

  const handleError = e => {
    if (src === fallbackSrc) {
      setSrc('');
    }
    if (!error) {
      setError(true);
      setSrc(fallbackSrc);
    }
    onError?.(e);
  };

  useEffect(() => {
    setSrc(remoteSrc);
  }, [remoteSrc]);

  return (
    <S.ImageWrapper className={className} $isCircular={isCircular}>
      <S.Image
        $isCircular={isCircular}
        $isCover={!width && !height}
        $isVisible={!!src}
        width={width}
        height={height}
        src={src}
        onLoad={handleLoad}
        onError={handleError}
        style={style}
        alt={alt}
      />
    </S.ImageWrapper>
  );
};

RemoteImage.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isCircular: PropTypes.bool,
  alt: PropTypes.string,
  /** @deprecated Use `className` instead and override it in your StyledComponent. */
  style: PropTypes.shape({}),
  className: PropTypes.string,
  remoteSrc: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
  fallbackSrc: PropTypes.string
};
